import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c(VBtn,{staticClass:"mx-auto",attrs:{"color":"highlightColor"},on:{"click":_vm.open}},[_vm._v(_vm._s(_vm.uploadLabel())+" "),_c(VIcon,[_vm._v("fa-upload")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }